const getStatusLabel = (type, status) => {
  if (type === 'devices') {
    switch (status) {
      case 'ON_WAREHOUSE':
        return 'label__on_warehouse'
      case 'WRITTEN_OFF':
        return 'label__written_off'
      case 'SHIPPED':
        return 'label__shipped'
      case 'READY_FOR_SHIPMENT':
        return 'label__ready_for_shipment'
      case 'READY_FOR_USE':
        return 'label__ready_for_use'
      default:
        return status
    }
  }
}

export default getStatusLabel
